function getType(context) {
  return context.$route.path.includes('routecontrols') ? 'tc' : 'site';
}

function hasInvoicePrivs(context) {
  return context.roleCheck(privs[getType(context)], 'Manage');
}

const privs = {
  site: 'pr_site',
  tc: 'pr_tc'
};

const urls = {
  site: '/sites/reports',
  tc: '/routecontrols/reports'
};

const filterNames = {
  site: 'sitereports',
  tc: 'tcreports'
};

const deviceGroupViewIds = {
  site: 2,
  tc: 3
};

const getAdvancedSearchFields = {
  site: [
    {
      text: 'Inactieve palen',
      value: 'has_inactive',
      type: 'boolean'
    }
  ],
  tc: []
};

const getTableFields = {
  site: [
    {
      text: 'Naam',
      value: 'report_code',
      link: '/sites/reports/{id}',
      width: '10%'
    },
    {
      text: 'Datum',
      value: 'date',
      width: '10%',
      filter: 'date'
    },
    {
      text: 'Type',
      value: 'sitetype',
      width: '15%'
    },
    {
      text: 'Serienummer',
      value: 'serial_nr',
      width: '10%'
    },
    {
      text: 'Installatienummer',
      value: 'installation_nr',
      width: '10%'
    },
    {
      text: 'Aantal palen',
      value: 'total_count',
      width: '5.5%'
    },
    {
      text: 'Actief',
      value: 'active_count',
      width: '5.5%'
    },
    {
      text: 'Gebruiker',
      value: 'user_name',
      width: '20%'
    }
  ],
  tc: [
    {
      text: 'Naam',
      value: 'report_code',
      link: '/routecontrols/reports/{id}',
      width: '11%'
    },
    {
      text: 'Datum',
      value: 'date',
      width: '10%',
      filter: 'date'
    },
    {
      text: 'Type',
      value: 'sitetype',
      width: '10%'
    },
    {
      text: 'Serienummer',
      value: 'serial_nr',
      width: '20%'
    },
    {
      text: 'Aantal palen',
      value: 'total_count',
      width: '9.5%'
    },
    {
      text: 'Actief',
      value: 'active_count',
      width: '9.5%'
    },
    {
      text: 'Gebruiker',
      value: 'user_name',
      width: '20%'
    }
  ]
};

export default {
  priv(context) {
    return privs[getType(context)];
  },
  overviewTitle: 'Rapporten',
  detailTitle: 'Rapport',
  deleteTitle: 'dit rapport',
  url(context) {
    return urls[getType(context)];
  },
  apiUrl: '/sitereports/',
  multiSelect(context) {
    return hasInvoicePrivs(context);
  },
  sortBy: ['report_code'],
  sortDesc: [true],
  deletable: true,
  editable: true,
  forEdit: true,
  newRecord: {
    conclusion: false,
    site: {
      user_address_id: 0,
      admin_address_id: 0,
      import_address_id: 0,
      owner_address_id: 0,
      roadauthority_address_id: 0,
      supervisor_id: 0
    }
  },
  filterName(context) {
    return filterNames[getType(context)];
  },
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'string'
  },
  advancedSearchFields(context) {
    const commonFields = [
      {
        text: 'Gebruiker',
        value: 'user_address_id',
        type: 'optionList',
        optionListName: 'addresses',
        optionListParams: { priv_user: 'yes' }
      },
      {
        text: 'Beheerder',
        value: 'admin_address_id',
        type: 'optionList',
        optionListName: 'addresses',
        optionListParams: { priv_manager: 'yes' }
      },
      {
        text: 'Type',
        value: 'sitetype_id',
        type: 'optionList',
        optionListName: 'sitetypes',
        optionListParams: {
          devicegroupview_id: deviceGroupViewIds[getType(context)]
        }
      },
      {
        text: 'Toezichter',
        value: 'supervisor_id',
        type: 'optionList',
        optionListName: 'supervisors'
      },
      {
        text: 'Periode van',
        value: 'date_start',
        type: 'date'
      },
      {
        text: 'Periode tot',
        value: 'date_end',
        type: 'date'
      },
      {
        text: 'Interventiepersoon',
        value: 'interventionperson_id',
        type: 'optionList',
        optionListName: 'interventionpersons'
      },
      {
        text: 'Meest recente rapporten',
        value: 'most_recent',
        type: 'boolean'
      },
      {
        text: 'Actief',
        value: 'is_active',
        type: 'boolean'
      }
    ];
    // Add invoiced filter if the user has manage privileges on this view
    if (hasInvoicePrivs(context)) {
      const invoicedFilter = {
        text: 'Gefactureerd',
        value: 'is_invoiced',
        type: 'optionList',
        optionList: [
          {
            value: false,
            text: 'Nee'
          },
          {
            value: true,
            text: 'Ja'
          }
        ]
      };
      commonFields.push(invoicedFilter);
    }
    return commonFields.concat(getAdvancedSearchFields[getType(context)]);
  },
  tableFields(context) {
    const commonFields = getTableFields[getType(context)];
    let invoicedColumn: any[] = [];
    // Add invoiced filter if the user has manage privileges on this view
    invoicedColumn = [
      {
        text: 'Gefactureerd',
        value: 'is_invoiced',
        type: 'boolean',
        width: '4%',
        sortable: false
      }
    ];
    return hasInvoicePrivs(context)
      ? commonFields.concat(invoicedColumn)
      : commonFields;
  },
  customEditable(item) {
    return !item.conclusion || item.isManage;
  }
};
